var dataLayerDebugMode = document.currentScript.getAttribute('data-debug-mode') === 'true';

if (is_gtm_loaded() && dataLayerDebugMode) {
    console.log('dataLayer-allPages - Debug mode: on');
}

function is_gtm_loaded() {
    let gtm_started_event = window.dataLayer.find(element => element['gtm.start']);
    if (!gtm_started_event) {
      return false; // Not even the GTM inline config has executed
    } else if (!gtm_started_event['gtm.uniqueEventId']) {
      return false; // GTM inline config has ran, but main GTM js is not loaded (likely AdBlock, NoScript, URL blocking etc.)
    }
    return true; // GTM is fully loaded and working
  }

function pushDataLayer(dataLayerEventName, productData) {
    if (dataLayerEventName && productData) {
        let ecommerce_data = {};

        ecommerce_data['currency'] = productData.gtmItemCurrency;
        ecommerce_data['value'] = productData.gtmItemPrice;
        ecommerce_data['item_list_name'] = productData.gtmItemListName;
        ecommerce_data['item_list_id'] = productData.gtmItemListId;
        ecommerce_data['items'] = [{
            'item_id': productData.gtmItemId,
            'item_name': productData.gtmItemName,
            'item_brand': productData.gtmItemBrand,
            'item_category': productData.gtmItemCategory,
            'item_category2': productData.gtmItemCategory2,
            'item_category3': productData.gtmItemCategory3,
            'price': productData.gtmItemPrice,
            'discount': '',
            'coupon': '',
            'currency': productData.gtmItemCurrency,
            'index': productData.gtmItemIndex,
            'item_sale_value': productData.gtmItemSaleValue,
            'item_sale': productData.gtmItemSale,
            'item_availability': productData.gtmItemAvailability,
            'affiliation': productData.gtmItemAffiliation,
            'item_variant': productData.gtmItemVariant,
            'item_sku': productData.gtmItemSku,
            'quantity': productData.gtmItemQuantity
        }];

        dataLayer.push({
            'event': dataLayerEventName,
            'ecommerce': ecommerce_data
        });

        if(Antonioli.customerId != ''){
            dataLayer.push({
              'user_id': Antonioli.customerId
            })
        };

        if (dataLayerDebugMode) {
            console.log('dataLayer debug - ' + dataLayerEventName + ': ' , ecommerce_data);
        }
    }
}

document.addEventListener('click', function(event) {
    if(!is_gtm_loaded()) {
        return;
    }
    var eventTargetA = event.target.closest('a');
    var eventTargetButton = event.target.closest('button');
    var dataLayerEventName = false;
    var productData = false;

    if (eventTargetButton && eventTargetButton.matches('.quantity__button-minus')) {
        /** DATALAYER: Remove From Cart by minus button **/
        if (dataLayerDebugMode) {
            console.log('Cart/Minicart remove from cart (the "-" or the trash bin button)');
        }

        let eventTargetButtonCartItemInfo = eventTargetButton.closest('.cart-item').querySelector('div.cart-item__details');

        if (
            eventTargetButtonCartItemInfo &&
            eventTargetButtonCartItemInfo.getAttribute('data-product-info')
        ) {
            dataLayerEventName = 'remove_from_cart';
            productData = JSON.parse(eventTargetButtonCartItemInfo.getAttribute('data-product-info'));
        }
    } else if (eventTargetA && eventTargetA.matches('.remove-cart-element')) {

            /** DATALAYER: Remove From Cart by label Remove **/
            if (dataLayerDebugMode) {
                console.log('Cart/Minicart remove from cart (the "-" or the trash bin button)');
            }

            let eventTargetACartItemInfo = eventTargetA.closest('.cart-item').querySelector('div.cart-item__details');

            if (
                eventTargetACartItemInfo &&
                eventTargetACartItemInfo.getAttribute('data-product-info')
            ) {
                dataLayerEventName = 'remove_from_cart';
                productData = JSON.parse(eventTargetACartItemInfo.getAttribute('data-product-info'));
            }
    }  else if (eventTargetButton && eventTargetButton.matches('.quantity__button-plus')) {
        /** DATALAYER: Add to Cart by plus button **/
        if (dataLayerDebugMode) {
            console.log('Cart/Minicart add to cart (the "+" button)');
        }

        let eventTargetButtonCartItemInfo = eventTargetButton.closest('.cart-item').querySelector('div.cart-item__details');

        if (
            eventTargetButtonCartItemInfo &&
            eventTargetButtonCartItemInfo.getAttribute('data-product-info')
        ) {
            dataLayerEventName = 'add_to_cart';
            productData = JSON.parse(eventTargetButtonCartItemInfo.getAttribute('data-product-info'));
            productData.gtmItemQuantity = 1;
        }

    } else if (event.target.matches('[data-action="add-to-cart"], [data-action="add-to-cart"] span')) {
        /** DATALAYER: Add to Cart by other **/
        if (dataLayerDebugMode) {
            console.log('All pages add to cart');
        }

        /* let eventTargetButton = event.target.closest('button');
        let eventTargetProductItem = event.target.closest('.cart-item-custom');

        if (
            eventTargetProductItem &&
            eventTargetProductItem.getAttribute('data-product-info') &&
            eventTargetButton &&
            eventTargetButton.getAttribute('data-variant-sku') &&
            eventTargetButton.getAttribute('data-variant-title')
        ) {
            dataLayerEventName = 'add_to_cart';
            productData = JSON.parse(eventTargetProductItem.getAttribute('data-product-info'));
            productData.gtmItemSku = eventTargetButton.getAttribute('data-variant-sku');
            productData.gtmItemVariant = eventTargetButton.getAttribute('data-variant-title');
        } 

        let eventTargetButton = event.target.closest("[data-action='add-to-cart']");

        if (eventTargetButton.getAttribute('data-action')) {

            let productWrapper = document.querySelector('div.grid__item.product__media-wrapper');
            let productVariant = document.querySelector('.product-variant-id').value;
            let productData = JSON.parse(productWrapper.getAttribute('data-product-info'));

            productData.gtmItemSku = productVariant;
            pushDataLayer('add_to_cart', productData);
        }
        */
    }

   // pushDataLayer(dataLayerEventName, productData);

});


/** DATALAYER: Add to wishlist **/
document.querySelectorAll('.iWishAddColl').forEach(element => element.addEventListener('click', (event) => {
    if (dataLayerDebugMode) {
        console.log('PDP/Listing add to wishlist');
    }

    let eventTargetProductItem = event.target.closest('div.card-wrapper');
    const eventName = event.target.classList.contains('iwishAdded') ? 'remove_from_wishlist' : 'add_to_wishlist'
    if (
        eventTargetProductItem &&
        eventTargetProductItem.getAttribute('data-product-info')
    ) {
        productData = JSON.parse(eventTargetProductItem.getAttribute('data-product-info'));
        productData.gtmItemVariant = '';

        pushDataLayer(eventName, productData);
    }
  })
);

 document.addEventListener('DOMContentLoaded', function() {
    if(!is_gtm_loaded()) {
        return;
    }
    if (window.location.href.includes('?login-success')) {
        let login_data = {
            'event': 'login',
            'method': 'website',
            'user_id': __st.cid
        };

        dataLayer.push(login_data);

        if(Antonioli.customerId != ''){
            dataLayer.push({
              'user_id': Antonioli.customerId
            })
        };

        if (dataLayerDebugMode) {
            console.log('dataLayer debug - login: ', login_data);
        }

    } else if (window.location.href.includes('?sign-up-success')) {
        let sign_up_data = {
            'event': 'sign_up',
            'method': 'website',
            'user_id': __st.cid
        };

        dataLayer.push(sign_up_data);

        if(Antonioli.customerId != ''){
            dataLayer.push({
              'user_id': Antonioli.customerId
            })
        };

        if (dataLayerDebugMode) {
            console.log('dataLayer debug - sign_up: ', sign_up_data);
        }
    }
});
